module.exports = __webpack_public_path__ + "static/media/default_fallback_10.d355db8d.png";